module.exports = __webpack_public_path__ + "static/media/021_v2_cc_orderform.38049263.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/docker/021_v2_cc_orderform.png
// module id = 400
// module chunks = 0